import { Box, styled } from '@mui/material';

export default styled(Box)`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin: 0 16px 0 0;
`;
